import React, { useState } from "react";

import clsx from "clsx";

import { PrimaryButton, TertiaryButton } from "@shared/buttons";

import { SegmentForm } from "../breakdowns/components/edit-breakdown/advanced-editor/segment-modal/segment-form";
import {
  type AdvancedBreakdownDescriptor,
  type AdvancedSegmentDescriptor,
} from "../breakdowns/components/edit-breakdown/advanced-editor/types";
import { validateAdvancedSegment } from "../breakdowns/components/edit-breakdown/advanced-editor/utils";

interface Props {
  isUpdate: boolean;
  breakdown: AdvancedBreakdownDescriptor;
  segment: AdvancedSegmentDescriptor;
  onCancel: () => void;
  onUpdate: (segment: AdvancedSegmentDescriptor) => void;
}

export const AdvancedSegmentForm = ({
  isUpdate,
  breakdown,
  segment,
  onCancel,
  onUpdate,
}: Props) => {
  const [localSegment, setLocalSegment] = useState(segment);

  return (
    <div className="mt-3">
      <SegmentForm
        breakdown={breakdown}
        segment={localSegment}
        onChange={(value) => setLocalSegment(value)}
      />
      <div
        className={clsx(
          "flex items-center justify-end gap-2 sticky bottom-0 pt-5 mb-[-20px]",
          "bg-white",
        )}
      >
        <TertiaryButton className="ml-2 font-bold" onClick={onCancel}>
          CANCEL
        </TertiaryButton>
        <PrimaryButton
          className="font-bold"
          onClick={() => {
            const validatedSegment = validateAdvancedSegment(localSegment);
            const errors = validatedSegment.errors;

            if (
              errors.name ||
              errors.output ||
              errors.level ||
              errors.matcher ||
              errors.priority
            ) {
              setLocalSegment(validatedSegment);
            } else {
              onUpdate(validatedSegment);
            }
          }}
        >
          {isUpdate ? "UPDATE SEGMENT" : "ADD SEGMENT"}
        </PrimaryButton>
      </div>
    </div>
  );
};
